import styled from 'styled-components'

const HomeStyle = styled.section``

export default HomeStyle
